





































import { Component } from 'vue-property-decorator';
import BusinessOnboardingModel from '../../BusinessOnboardingModel.vue';
import gsap from 'gsap';
import { Picture } from '@/components/atoms';
import eventBus from '@/utils/eventBus';

@Component({
  components: { Picture }
})
export default class WelcomeTwismConnections extends BusinessOnboardingModel {
  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  onComplete() {
    this.finishOnboarding(false, true);
    eventBus.$emit('enableScroll');
  }

  enterAnimation(tl: gsap.core.Timeline) {
    tl.to(this.$refs.mainImg, {
      bottom: 0,
      top: 0,
      duration: 3,
      opacity: 1,
      ease: 'elastic.inOut(1,0.9)'
    });
    tl.to(
      this.$refs.circles,
      {
        bottom: 0,
        top: this.$mobileCheck() ? -31 : -200,
        duration: 5,
        ease: 'elastic.inOut(1,0.9)'
      },
      '<1'
    );
    tl.to(
      this.$refs.description,
      {
        bottom: this.$mobileCheck() ? -400 : 45,
        top: 0,
        duration: 5,
        ease: 'elastic.inOut(1,0.9)'
      },
      '<'
    );
    tl.to(
      this.$refs.title,
      {
        bottom: 0,
        top: this.$mobileCheck() ? 492 : 416,
        opacity: 1,
        duration: 5,
        ease: 'elastic.inOut(1,0.9)'
      },
      '<'
    );
    tl.to(
      this.$refs.content,
      {
        duration: 0.5,
        opacity: 1
      },
      '<1'
    );
  }

  exitAnimation(tl: gsap.core.Timeline) {
    tl.to(this.$refs.content, {
      duration: 1,
      opacity: 0,
      translateY: -200,
      delay: 0.4
    });
    tl.to(
      this.$refs.title,
      {
        duration: 1,
        opacity: 0,
        translateY: -200
      },
      '<'
    );
    tl.to(
      this.$refs.mainImg,
      {
        duration: 1,
        opacity: 0
      },
      '<'
    );
    tl.to(
      this.$refs.mainImg,
      {
        duration: 1,
        translateY: -150
      },
      '<'
    );
  }

  mounted() {
    const tl = gsap.timeline({
      onComplete: this.onComplete
    });

    this.enterAnimation(tl);
    this.exitAnimation(tl);

    tl.play();
  }
}
